import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import trans from 'common/tools/translations/trans';

import AuthenticatedLink from 'website/components/user/AuthenticatedLink';
import { getOpinionForEntity } from 'website/reducers/data/helper';
import { openReviewModal } from 'website/services/modal';
import { addToDatalayer } from 'website/tracking/googletagmanager';

class ReviewLink extends Component {
  constructor(props) {
    super(props);
    this.state = {
      passiveLoginDone: false
    };
    this.showModal = this.showModal.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      nextProps.user.passiveLoginDone === true &&
      prevState.passiveLoginDone === false &&
      window.location &&
      window.location.hash === '#edit-review'
    ) {
      return {
        passiveLoginDone: true
      };
    }
    return null;
  }

  handleGtmLayer() {
    addToDatalayer(
      {
        event: 'eventGA',
        eventCategory: 'social-action',
        eventAction: 'critique'
      },
      {
        movie_distributor: 'movie_distributors',
        clicked_movie_id: 'movie_id'
      }
    );
  }

  showModal() {
    if (this.props.disabled) {
      return;
    }

    this.handleGtmLayer();
    openReviewModal({
      entityId: this.props.entityId,
      openOn: this.props.openOn
    });
  }

  render() {
    const {
      className,
      userRating,
      showLabel = true,
      showIcon = true,
      disabled = false,
      label: propLabel,
      labelClassName = ''
    } = this.props;

    const label =
      propLabel ??
      (userRating ? trans('bam.add-review') : trans('bam.write-review'));

    const buttonClass = `button${showIcon ? ' icon icon-pen' : ''}${disabled ? ' disabled' : ''}`;

    return (
      <AuthenticatedLink
        className={className}
        onClick={this.showModal}
        aria-disabled={disabled}
        tabIndex={disabled ? -1 : 0}
        onKeyDown={e => disabled && e.preventDefault()}
      >
        <span className={classnames(buttonClass, labelClassName)}>
          {showLabel ? label : null}
        </span>
      </AuthenticatedLink>
    );
  }
}

ReviewLink.propTypes = {
  className: PropTypes.string.isRequired,
  entityId: PropTypes.string.isRequired,
  openOn: PropTypes.string,
  user: PropTypes.object.isRequired,
  userRating: PropTypes.number,
  showLabel: PropTypes.bool,
  showIcon: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  labelClassName: PropTypes.string
};

ReviewLink.defaultProps = {
  openOn: null,
  showLabel: true,
  showIcon: true,
  disabled: false,
  label: null,
  labelClassName: ''
};

function mapStateToProps(state, ownProps) {
  const opinion = getOpinionForEntity(ownProps.entityId, state.data);
  return {
    user: state.user,
    userRating: opinion?.rating ?? null
  };
}

export default connect(mapStateToProps)(ReviewLink);
